/** postMessage + BroadcastChannel payloads — must stay in sync with WaSuccess / main listener */
export const WA_CONNECTION_SUCCESS_MESSAGE = "wa-connection-success";
export const WA_CONNECTION_FAILURE_MESSAGE = "wa-connection-failure";
export const WA_BC_NAME = "salesgear-wa-auth";

/** Popup sets this when the connect API finished OK so the opener can close without relying on window.opener (often null after OAuth). */
export const WA_POPUP_DONE_KEY = "__salesgearWaConnectDone";

export function broadcastWaAuth(payload) {
  if (typeof BroadcastChannel === "undefined") return;
  try {
    const bc = new BroadcastChannel(WA_BC_NAME);
    bc.postMessage(payload);
    bc.close();
  } catch (e) {
    // ignore
  }
}
